import { useState, useEffect } from 'react';

type AnimatedNumberProps = {
    number: number;
    speed?: number;
    step?: number;
    shouldAnimate?: boolean;
    className?: string;
};

const AnimatedNumber = ({
    number,
    speed = 80,
    step,
    shouldAnimate,
    className,
}: AnimatedNumberProps) => {
    const [currentNumber, setCurrentNumber] = useState(0);

    useEffect(() => {
        let internalStep = step || Math.ceil(number / 50);
        const adjustedSpeed = shouldAnimate ? speed : 1; // Adjust speed based on shouldAnimate

        const interval = setInterval(() => {
            setCurrentNumber(prev => {
                if (prev + internalStep >= number) {
                    clearInterval(interval);
                    return number;
                }
                if (!shouldAnimate) {
                    internalStep = parseInt(internalStep * 1.1, 10); // Double the step if shouldAnimate is false
                }
                return prev + internalStep;
            });
        }, adjustedSpeed); // Use adjusted speed here

        return () => clearInterval(interval);
    }, [number, speed, step, shouldAnimate]); // Add shouldAnimate to dependency array

    return <div className={className}>{currentNumber}</div>;
};

export default AnimatedNumber;
